import getSingleMethodTitles from 'routes/formsView/IdentityVerificationViews/IdentityView/utils/getSingleMethodTitles';

const getSingleIdentificationOption = ({
    identificationMethods,
    isCarrouselActive,
    isSelectedVideoselfieWithBiometrics,
}) =>
    isCarrouselActive
        ? null
        : getSingleMethodTitles({
              isSelectedVideoselfieWithBiometrics,
              identificationMethod: identificationMethods[0],
          });

export default getSingleIdentificationOption;
